import { handleActions } from 'redux-actions';
import selectArticle from '../../actions/selectArticle';
/**
 * Stores the slug of the currently selected article.
 *
 * Can be updated via the `selectArticle` action in the ghost model. To deselect an article, dispatch `selectArticle(null)` or select a new article.
 *
 * ```js
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 * const { selected } = ghost.reducers;
 *
 * // Note that this is not how you should actually use `selected`, this is just
 * // to demonstrate what it can return when called by redux
 * selected(); // null
 * selected('', ghost.actions.selectArticle('slug-1')); // 'slug-1'
 *
 * // To select data from this reducer in a component
 * import { useSelector } from 'react-redux';
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 * const Test = () => {
 *   // Note that you may need to change this depending on where the ghost
 *   // model is integrated in your store
 *   const selectedSlug = useSelector((state) => state.ghost.selected);
 *
 *   // Note that there is also a prebuilt hook that can help you here
 *   const article = ghost.hooks.useSelectedArticle();
 *
 *   return <div>Test</div>
 * };
 */

var selected = handleActions(new Map([[selectArticle, function (state, action) {
  return action.payload;
}]]), null);
export default selected;